import { getGetters } from '@owlsdepartment/vuex-typed';

import { TerminalModel } from '@/store/models/Terminal';

import { terminalListKey } from './keys';
import { TerminalState } from './state';

const getters = {
	terminalListByName:
		(state: TerminalState) =>
		(name: string): Array<TerminalModel> => {
			return state.lists[name]?.map((id: number) => state.terminals[id]) ?? [];
		},
	/**
	 * Lista WYBORU — kreator nowego zamówienia. Bez urządzeń wycofanych (GLA-18).
	 */
	terminalListByProsthesisId:
		(state: TerminalState) =>
		(id: number): Array<TerminalModel> => {
			return getters.terminalListByName(state)(terminalListKey(id));
		},

	/**
	 * Lista PODGLĄDU istniejącego zamówienia — także z urządzeniami wycofanymi (GLA-155).
	 * Osobny klucz, nie osobny filtr: inaczej te same dane odpowiadałyby na dwa pytania.
	 */
	terminalListForOrderPreview:
		(state: TerminalState) =>
		(id: number): Array<TerminalModel> => {
			return getters.terminalListByName(state)(terminalListKey(id, true));
		},
	terminalListDefault: (state: TerminalState) => getters.terminalListByName(state)('default'),
	getTerminalById:
		(state: TerminalState) =>
		(id: number): TerminalModel | undefined => {
			return state.terminals[id];
		},
	getTerminalGloves: (state: TerminalState) => (slug: string) => state.gloves[`gloves_${slug}`],
};

export type TerminalGetters = typeof getters;
export const {
	terminalListByName,
	terminalListByProsthesisId,
	terminalListForOrderPreview,
	terminalListDefault,
	getTerminalById,
	getTerminalGloves,
} = getGetters(getters, 'terminal');
export default getters;
